<template>
  <v-container>
      <v-row>
          <v-col>
                <h1 class="h3">Documentation</h1>
                <p>Procédures de fonctionnement du Middleware</p>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h2 class="h4">Préscriptions</h2>
              <p>Procédures liées aux préscriptions</p>
              <ul>
                  <li><router-link to="prescriptions#global">Principes de base</router-link></li>
                  <li><router-link to="prescriptions#list">Liste des préscriptions et status</router-link></li>
                  <li><router-link to="prescriptions#create">Création de préscriptions</router-link></li>
                  <li><router-link to="prescriptions#quote">Quotation</router-link></li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h2 class="h4">Commandes</h2>
              <p>Procédures liées aux commandes</p>
              <ul>
                  <li><router-link to="orders#global">Principes de base</router-link></li>
                  <li><router-link to="orders#list">Liste des commandes et status</router-link></li>
                  <li><router-link to="orders#create">Création de commande sans préscription</router-link></li>
                  <li><router-link to="orders#discount">Discount</router-link></li>
                  <li><router-link to="orders#billing">Facturation</router-link></li>
                  <li><router-link to="orders#stock">Envoi au stock pour montage</router-link></li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h2 class="h4">Factures</h2>
              <p>Procédures liées aux factures</p>
              <ul>
                  <li><router-link to="invoices#global">Principes de base</router-link></li>
                  <li><router-link to="invoices#sent">Envoi d'une facture au client</router-link></li>
                  <li><router-link to="invoices#payout">Dépot et paiement</router-link></li>
                  <li><router-link to="invoices#cancel">Annulation d'une facture</router-link></li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h2 class="h4">Builds</h2>
              <p>Procédures liées à la fabrication et envoi des commandes</p>
              <ul>
                  <li><router-link to="builds#global">Principes de base</router-link></li>
                  <li><router-link to="builds#picking">Picking</router-link></li>
                  <li><router-link to="builds#pickwave">Pick Wave</router-link></li>
                  <li><router-link to="builds#handling">Handling</router-link></li>
              </ul>
          </v-col>
      </v-row>
      <v-row>
          <v-col>
              <h2 class="h4">Gestion des inventaires</h2>
              <p>Procédures lié à la gestion de produits et de l'inventaire</p>
              <ul>
                  <li><router-link to="inventory#createproduct">Création de produits</router-link></li>
                  <li><router-link to="inventory#catalog">Catalogues</router-link></li>
                  <li><router-link to="inventory#stock">Gestion du stock d'un produit</router-link></li>
                  <li><router-link to="inventory#warehouse">Gestion du Warehouse et des Locations</router-link></li>
                  <li><router-link to="inventory#supplier">Fournisseurs</router-link></li>
                  <li><router-link to="inventory#po">Purchase Orders</router-link></li>
              </ul>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>